// Shared SSE block consumer — used by both Sentinel chat and Sentinel Suggest streaming.
//
// Usage:
//   await consumeSSE(response, ({ event, data }) => {
//     if (event === "delta") ...   // accumulate text
//     if (event === "final") ...   // structured payload (JSON string)
//     if (event === "error") return false;   // stop reading
//     if (event === "done") return false;
//   });

function parseSSEBlock(block) {
  let event = "message";
  const dataLines = [];
  for (const line of block.split("\n")) {
    if (line.startsWith("event: ")) event = line.slice(7).trim();
    else if (line.startsWith("data: ")) dataLines.push(line.slice(6));
  }
  return { event, data: dataLines.join("\n") };
}

export async function consumeSSE(response, onEvent) {
  if (!response.ok || !response.body) {
    const detail = await response.text();
    throw new Error(detail || `HTTP ${response.status}`);
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let streaming = true;
  while (streaming) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) !== -1) {
      const block = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      if (!block.trim()) continue;
      const parsed = parseSSEBlock(block);
      const cont = onEvent(parsed);
      if (cont === false) {
        streaming = false;
        break;
      }
    }
  }
}
